import styled from '@emotion/styled';

interface Props {
  isShowSearchInput?: boolean;
}

// 데스크톱 GNB는 입력창을 항상 노출하므로, lazy 청크 로드 전까지
// 340×48 슬롯(GNB GlobalSearchContainer)을 채우는 스켈레톤으로 CLS를 막는다.
// 모바일(isShowSearchInput=false)은 입력창을 그리지 않아 차지하는 자리가 없다.
export default function GlobalSearchFallback({ isShowSearchInput = true }: Props) {
  if (!isShowSearchInput) {
    return null;
  }

  return <Skeleton aria-hidden />;
}

const Skeleton = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.04);
`;
